// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__m7KJv","navmenu":"Navbar_navmenu__j-95D","hamburguer":"Navbar_hamburguer__BPpBz","navmenuactive":"Navbar_navmenuactive__WFrVQ"};